export default {
  dashboard: {
    title: '工作台',
    welcome: '欢迎回来',
    refresh: '刷新数据',
    lastUpdate: '最后更新',

    // 夜景欢迎横幅
    banner: {
      ready: '今日已就绪',
      subtitle: '函云双子星智算平台 1.0 · AI-DRIVEN RETAIL INTELLIGENCE PLATFORM',
      computeUsage: '算力利用率',
      aiTasks: 'AI 任务进行中',
    },

    // KPI卡片
    kpi: {
      signingRate: '签约率',
      activeIntentions: '活跃意向',
      newContractsThisMonth: '本月新签',
      vacantShops: '空置铺位',
      monthlyReceivable: '本月应收',
      monthlyReceived: '本月已收',
      collectionRate: '收缴率',
      overdueAmount: '逾期欠款',
      operatingMerchants: '营业商户',
      renovatingCount: '装修中',
      openingRate: '开业率',
      myTaskTotal: '我的任务',
      myTaskCompleted: '已完成',
      myTaskDueThisWeek: '本周到期',
      myCompletionRate: '完成率',
      pendingWorkOrders: '待处理工单',
      urgentWorkOrders: '紧急工单',
      todayWorkOrders: '今日新建',
      overdueWorkOrders: '超时工单',
      unitYuan: '元',
      unitCount: '个'
    },

    // 待办事项
    todo: {
      title: '待办事项',
      all: '全部',
      overdue: '已逾期',
      expiring: '即将到期',
      approval: '待审批',
      rejected: '被驳回',
      task: '待办任务',
      empty: '暂无待办事项',
      viewAll: '查看全部',
      overdueDays: '逾期{days}天',
      dueDateLabel: '截止日期'
    },

    // 快捷入口
    quick: {
      title: '快捷入口',
      merchantWorkbench: '招商工作台',
      contractManage: '合同管理',
      billingManage: '账单管理',
      renovationManage: '装修管理',
      policyManage: '政策管理',
      brandLibrary: '品牌库',
      feeEntry: '费用录入',
      financeReport: '财务报表',
      salesReport: '营业报告',
      workorderManage: '工单管理',
      createWorkorder: '新建工单'
    },

    // 通知消息
    notification: {
      title: '消息通知',
      typeAll: '全部',
      typeBusiness: '业务通知',
      typeApproval: '审批通知',
      typeSystem: '系统通知',
      markAllRead: '全部已读',
      markRead: '标记已读',
      noNotification: '暂无通知',
      viewAll: '查看全部通知',
      unreadCount: '{count}条未读'
    },

    // 图表
    chart: {
      todoDistribution: '待办分布',
      shopOverview: '铺位概况'
    }
  }
}
